/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {AssetType, EntityStatus} from '@ion/core/src/types/entities';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@ion/applications/src/types/redux';

export enum ReportsMode {
  AssetHistory = 'AssetHistory',
  ReportsDashboard = 'ReportsDashboard',
  ShipmentHistory = 'ShipmentHistory'
};

// defines the report tab mode...
export enum ReportTabMode {
  AssetHistory = 'AssetHistory',
  ShipmentHistory = 'ShipmentHistory',
  Default = 'Default'
};

export interface AdminAssetGridRows {
  group: string;
  name: string;
  type: AssetType;
  category: string;
  schedule: string
  device: string;
  associations: {
    href: string;
    rel: string;
    status: string;
    title: string;
  }[];
  status: EntityStatus;
  assetId: string;
};

export enum ExportContext {
  asset = 'asset',
  device = 'device',
  driver = 'driver',
  route = 'route',
  operator = 'operator',
  geofence = 'geofence',
  geofenceEvents = 'geofenceEvents',
  group = 'group',
  ioProfile = 'ioprofile',
  notification = 'notification',
  role = 'role',
  schedule = 'schedule',
  user = 'user',
  serviceSchedule = 'serviceSchedule',
  serviceItem = 'serviceItem',
  maintenanceDashboard = 'maintenanceDashboard',
  maintenanceSchedule = 'maintenanceSchedule',
  maintenanceHistory = 'maintenanceHistory',
  assetHistory = 'assetHistory',
  shipmentHistory = 'shipmentHistory',
  assetTracking = 'assetTracking',
  crashboxx = 'crashboxx',
  tripList = 'tripList'
}

// defines the report type.
export enum ReportType {
  detail = 'detail',
  summary = 'summary'
}
